import { Container, Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import ShopAdds from "../../components/shopAds/ShopAdds";
import Businessprofiletitle from "../../components/BusinessProfile/Component/Title/businessprofiletitle";
import Rawmaterialcard from "../../components/BusinessProfile/Component/Rawmaterialcard/Rawmaterialcard";
import Timeline from "../../components/Timeline/timeline";
import BackArrow from "../../components/backArrow";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Viewbusinessfriend from "../../pages/UserProfile/Components/Profile_connectivity/Viewbusiness/index";
import { useGetPublicAgainstShopQuery } from "../../features/connection/connectionApiSlice";
import useIncomingMessageNotice from "../../hooks/useIncomingMessageNotice";
import "./companyBusinessProfile.css";

const CompanyBusinessProfile = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);
  const { receivedMessageCount, clearReceivedMessageCount } =
    useIncomingMessageNotice({ userId: name?._id, shopId: id });

  const handleOpenChat = () => {
    clearReceivedMessageCount();
    const chatParams = new URLSearchParams({
      type: "shop",
      profileId: id || "",
      ...(createPost?.businessType
        ? { businessType: createPost.businessType }
        : {}),
      returnTo: location.pathname,
    });
    const chatUrl = `/messages?${chatParams.toString()}`;
    const newTab = window.open(chatUrl, "_blank");
    if (!newTab) {
      navigate("/messages", {
        state: {
          returnTo: location.pathname,
          messageProfile: {
            type: "shop",
            profileId: id,
            businessType: createPost?.businessType,
          },
        },
      });
    }
  };

  const [tabsData, setTabsData] = useState([]);
  const [activeTab, setActiveTab] = useState("");
  const [profileshowhide, setProfileshowhide] = useState(false);

  const [createPost, setCreatePost] = useState({
    shopid: id,
    userid: name?._id,
    businessType: "jobsCompany",
    my: [
      {
        heading: "",
        content: "",
        img: [""],
        video: [""],
      },
    ],
  });

  // RTK Query: fetch public/shop connections for this company profile
  const {
    data: connectionsData,
    isLoading: loading,
  } = useGetPublicAgainstShopQuery(
    {
      businessType: "jobsCompany",
      shopid: id,
      userid: name?._id,
    },
    { skip: !id || !name?._id }
  );

  // Build tabs from the response data whenever it changes
  useEffect(() => {
    if (connectionsData?.data) {
      const ownBT = createPost?.businessType || "jobsCompany";
      const responseData = connectionsData.data;
      const dynamicTabs = Object.keys(responseData).map((key) => ({
        eventKey: key,
        title:
          key.charAt(0).toUpperCase() +
          key.slice(1).replace(/([A-Z])/g, " $1"),
        data: responseData[key],
      }));
      const withOwn = dynamicTabs.some((t) => t.eventKey === ownBT)
        ? dynamicTabs
        : [
            {
              eventKey: ownBT,
              title:
                ownBT.charAt(0).toUpperCase() +
                ownBT.slice(1).replace(/([A-Z])/g, " $1"),
              data: [],
            },
            ...dynamicTabs,
          ];
      setTabsData(withOwn);
      setActiveTab((prev) => {
        if (prev && withOwn.some((t) => t.eventKey === prev)) return prev;
        return ownBT;
      });
    }
  }, [connectionsData, createPost?.businessType]);

  const handleTabSelect = (eventKey) => {
    setActiveTab(eventKey);
  };

  const getActiveTabData = () => {
    const activeTabData = tabsData.find((tab) => tab.eventKey === activeTab);
    return activeTabData ? activeTabData.data : [];
  };

  return (
    <>
      <Container className="company-business-profile-page">
        <Row className="company-business-profile-row">
          <Col lg="7" className="screenHeight p-0 company-business-profile-column">
            {profileshowhide ? (
              <Viewbusinessfriend
                id={id}
                profileurl="/Home-Made-Item-Userprofile"
                setProfileshowhide={setProfileshowhide}
                mybusinessType={createPost?.businessType}
                viewBusinessType={profileshowhide}
              />
            ) : (
              <div className="border b-radius company-business-profile-panel">
                <BackArrow back="/company-form" />
                <ShopAdds />
                <Businessprofiletitle
                  linkurl="/company-profile"
                  id={id}
                  name="Company Business Profile"
                />
                <Rawmaterialcard
                  id={id}
                  setProfileshowhide={setProfileshowhide}
                  profileLayout
                />
              </div>
            )}
          </Col>

          <Col
            lg="5"
            sm="12"
            className="ps-4 screenHeight company-business-profile-column"
            style={{ position: "relative" }}
          >
            <div className="border b-radius company-business-profile-panel">
              <Timeline
                tabsData={tabsData}
                activeTab={activeTab}
                onTabSelect={handleTabSelect}
                tabData={getActiveTabData()}
                loading={loading}
                createPost={createPost}
                setCreatePost={setCreatePost}
                setLoading={() => {}}
                id={id}
                mybusinessType={createPost?.businessType}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CompanyBusinessProfile;
